import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import MegaMenu from "./components/MegaMenu";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import WMS from "./pages/services/WMS";
import WIP from "./pages/services/WIP";
import Inventory from "./pages/services/Inventory";
import AssetTracking from "./pages/services/AssetTracking";
import MobileApps from "./pages/solutions/MobileApps";
import Barcode from "./pages/solutions/Barcode";
import IoT from "./pages/solutions/IoT";
import RFID from "./pages/solutions/RFID";
import Manufacturing from "./pages/industries/Manufacturing";
import Retail from "./pages/industries/Retail";
import Healthcare from "./pages/industries/Healthcare";
import Logistics from "./pages/industries/Logistics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <MegaMenu />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/wms" element={<WMS />} />
          <Route path="/services/wip" element={<WIP />} />
          <Route path="/services/inventory" element={<Inventory />} />
          <Route path="/services/asset-tracking" element={<AssetTracking />} />
          <Route path="/solutions/mobile-apps" element={<MobileApps />} />
          <Route path="/solutions/barcode" element={<Barcode />} />
          <Route path="/solutions/iot" element={<IoT />} />
          <Route path="/solutions/rfid" element={<RFID />} />
          <Route path="/industries/manufacturing" element={<Manufacturing />} />
          <Route path="/industries/retail" element={<Retail />} />
          <Route path="/industries/healthcare" element={<Healthcare />} />
          <Route path="/industries/logistics" element={<Logistics />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
